const LOCAL_API_URL = "http://localhost:4000";

function isLocalhost(hostname) {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

export function getApiBaseUrl() {
  if (typeof window === "undefined") {
    return LOCAL_API_URL;
  }

  const envUrl = process.env.REACT_APP_API_BASE_URL?.trim();
  if (envUrl) {
    return envUrl.replace(/\/+$/, "");
  }

  return isLocalhost(window.location.hostname)
    ? LOCAL_API_URL
    : window.location.origin;
}
